import {
  Box,
  Chip,
  Divider,
  ListItemButton,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { headerContent } from "../../Components/CustomTexts";
import globalColors from "../../globalColors";
import CustomTable from "../../Components/CustomTable";
import CustomTab from "../../Components/CustomTab";
import { Fragment, useEffect, useState } from "react";
import { useAppDispatch, useAppSelecter } from "../../hooks/storeHooks";
import {
  DeletionItem,
  deletionsListResponse,
  fetchDeletionsList,
} from "../../store/slices/pendingApproval";
import { convertFirstUpper, formatTimestamp } from "../../Regex";
import { ObjectValues } from "../login";
import { moreRound } from "../../assets/svgs";
import CustomPopover from "../../Components/CustomPopover";
import { rowVerticalCenter } from "../../GlobalStyles";
import CustomIconButton from "../../Components/CustomIconButton";
import CustomContainedButton from "../../Components/CustomContainedButton";
import { CustomListItem } from "../../Components/CustemListItem";
import BulkDelete, { deleteOptions } from "../exams/BulkDelete";
import {
  contents,
  getServerEnvironment,
} from "../../store/slices/constants/staticContents";
import apiRequest from "../../request/apiRequest/apiRequest";
import { allApis } from "../../request/config";
import { showSnack } from "../../store/slices/constants";
import { Info } from "@mui/icons-material";
import moment from "moment";
import CustomSearch from "../../Components/CustomSearch";

function Pendingapproval() {
  const dispatch = useAppDispatch();
  const { deletionsList, loading } = useAppSelecter(
    (state: ObjectValues) => state.pendingApprovalSlice
  );
  const userSlice = useAppSelecter(
    (state: ObjectValues) => state.userSlice.loggedUser
  );
  const sendBasecampNotification = async ({
    deletion,
    action, // 'approved' | 'rejected' | 'updated'
  }: {
    deletion: {
      topic_name: string;
      action_type: string;
      options: string[];
      remark: string;
      type: string;
      type_id: number;
      created: string;
      created_by: number;
      created_at: string;
      modified: string;
      modified_at: string;
      id: string | number;
    };
    action: "approved" | "rejected" | "updated";
  }) => {
    const actionLabel = {
      approved: "✅ Approved",
      rejected: "❌ Rejected",
      updated: "✏️ Updated",
    }[action];
    // ${deletion.action_type}
    const options = deletion.options.map(
      (s) => `• ${deleteOptions.find((d) => d.api === s)?.label}`
    );
    const content = `
  <b>${actionLabel} Bulk Delete Request (Topic) #${deletion.id}</b>
  ${getServerEnvironment()}
  <br>
  <br>
  <hr style="border: none; height: 2px; background-color: #000;" >
  <br>
${deletion.topic_name} (ID: ${deletion.type_id})
 <br>
${deletion.remark ?? "No Remark"}
 <br>
Details
<br>
  ${options.join("<br>")}
<br>
<br>
<hr style="border: none; height: 2px; background-color: #000;" >
<br>
Requested By:
<br>
${deletion.created} (ID: ${deletion.created_by})
<br>
${moment(new Date(deletion.created_at)).format("DD-MMMM-YYYY, h:mm:ss A")}<br>
<br>
${
  action === "updated"
    ? "Updated"
    : action === "rejected"
    ? "Rejected"
    : "Approved"
} By:
<br>
 ${userSlice.user_data.full_name} (ID: ${userSlice.user_data.id})
<br>
${moment(new Date()).format("DD-MMMM-YYYY, h:mm:ss A")}`;

    try {
      const response = await fetch(
        "https://3.basecamp.com/4504806/integrations/SvbEtQWkk3UALjkusowMKfop/buckets/24379316/chats/8524805166/lines",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({ content }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send notification");
      }

      console.log("Notification sent successfully!");
    } catch (error) {
      console.error("Error sending Basecamp notification:", error);
    }
  };

  const statusFilters = ["Completed", "Rejected", "Pending"];
  const [selectedStatus, setSelectedStatus] = useState<any>("Pending");

  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);

  useEffect(() => {
    dispatch(
      fetchDeletionsList(
        `${selectedStatus}${
          debouncedSearchText ? `&topic_name=${debouncedSearchText}` : ""
        }`
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus, debouncedSearchText]);
  const defaultDetail = { open: false, type: null, row: null };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const [details, setDetails] = useState<{
    open: boolean;
    type: "update" | "view" | "reject" | "approve" | null;
    row: null | DeletionItem;
  }>(defaultDetail);
  const updateunction = async (row: any, payload: any) => {
    const response: any = await apiRequest({
      api: allApis.bulk_delete(`${row?.row?.id}/`),
      payload:
        details.type === "update"
          ? {
              ...row.row,
              remark: row[contents.feedback] ?? "",
              options: payload,
            }
          : { status: details.type === "reject" ? "Rejected" : "Approved" },
      method: "PUT",
    });
    if (!response || (response && response.error)) {
    } else {
      sendBasecampNotification({
        deletion: {
          ...row.row,
          remark: row[contents.feedback] ?? "",
          options: payload,
        },
        action:
          details.type === "reject"
            ? "rejected"
            : details.type === "approve"
            ? "approved"
            : "updated",
      });
      dispatch(fetchDeletionsList(selectedStatus));
      dispatch(
        showSnack({
          message: `Deletion request of ${row.row.topic_name} has been ${
            details.type === "update"
              ? "Updated"
              : details.type === "reject"
              ? "Rejected"
              : "Approved"
          }.`,
          severity: "success",
          open: true,
        })
      );
    }

    await setDetails(defaultDetail);
    return response;
  };
  const { results, count }: deletionsListResponse = deletionsList;
  const { results: list, status_counts }: any = results;
  const tableContent: any = (it: any) => {
    // checkPermisions(
    //   userSlice?.user_permissions ?? [],
    //   "view",
    //   getPermissionName(),
    //   dockedCard.title == "questions" ? "content" : "syllabus"
    // ) &&

    const buttonarr = (row: { row: DeletionItem }) => [
      {
        content: "approve",
        sx: { minWidth: "fit-content" },
        onClick: () => {
          setDetails({
            open: true,
            type: "approve",
            row: row.row,
            [contents.feedback]: row.row.remark,
          });
        },
      },
    ];
    const actionarr = [
      {
        label: "Reject",
        icon: "",
        onclick: (row: DeletionItem) => {
          setDetails({
            open: true,
            type: "reject",
            row: row,
            [contents.feedback]: row.remark,
          });
        },
      },
      {
        label: "Update",
        icon: "",
        onclick: (row: DeletionItem) => {
          setDetails({
            open: true,
            type: "update",
            row: row,
            [contents.feedback]: row.remark,
          });
        },
      },
    ];
    const actionContent: any = (ss: any) => {
      return (
        <Box sx={{ height: "100%", ...rowVerticalCenter }}>
          {selectedStatus === "Pending" && (
            <Stack
              spacing="3px"
              justifyContent={"center"}
              sx={{ marginRight: "6px", flex: 8 }}
            >
              {buttonarr(ss).map((button: any, i: number) => {
                return i === 1 ? (
                  <CustomIconButton
                    key={button.content}
                    {...button}
                    sx={{
                      ...button.sx,
                      fontSize: "0.8rem !important",
                      minWidth: "fit-content",
                    }}
                    variant={"outlined"}
                  />
                ) : (
                  <CustomContainedButton
                    key={button.content}
                    otherProps={{
                      variant: "contained",
                      ...button,
                      key: button.content,
                      sx: {
                        ...button.sx,
                        fontSize: "0.8rem !important",
                        minWidth: "fit-content",
                      },
                    }}
                    {...button}
                  />
                );
              })}
            </Stack>
          )}
          {selectedStatus === "Pending" && actionarr.length > 0 ? (
            <CustomPopover
              mt="5px !important"
              icon={moreRound}
              content={
                <Stack spacing={"5px"} minWidth={"75px"}>
                  {actionarr.map(
                    (
                      {
                        label,
                        icon,
                        onclick,
                      }: { label: string; icon?: any; onclick: any },
                      i: number
                    ) => {
                      return (
                        <Fragment key={label}>
                          <CustomListItem
                            onClick={() => {
                              onclick(ss.data);
                            }}
                            key={label}
                            alignItems="flex-start"
                            sx={{
                              display: "block",
                              color: globalColors.primary.black,
                              borderRadius: "7px",
                              transition: "background-color 0.3s ease", // Optional: Add a transition for smoother effect
                              "&:hover": {
                                background: globalColors.primary.lightGrey, // Change the background color on hover
                                color: globalColors.primary.black,
                                borderRadius: "7px", // Change the text color on hover
                              },
                              mb: "5px",
                              p: "0",
                            }}
                          >
                            <ListItemButton
                              sx={{
                                maxHeight: "40px",
                                padding: "5px 8px !important",
                                borderRadius: "0 !important",
                                background: "transparent !important",
                              }}
                            >
                              {icon}
                              <ListItemText
                                sx={{ ...{ m: "0", p: "0" } }}
                                primary={label ?? ``}
                              />
                            </ListItemButton>
                          </CustomListItem>
                          {i + 1 !== actionarr.length && <Divider />}
                        </Fragment>
                      );
                    }
                  )}
                </Stack>
              }
            />
          ) : (
            ""
          )}
        </Box>
      );
    };
    return (
      <Stack
        height={"100%"}
        spacing={"10px"}
        m="0"
        id="table-width"
        width="100%"
        overflow={"hidden"}
      >
        {details.open && (
          <BulkDelete
            setDialog={setDetails}
            dialogs={{
              ...details,
              selected: {
                name: details.row?.topic_name ?? "",
                request_date: details.row?.created_at
                  ? formatTimestamp(details.row?.created_at)
                  : "",
              },
              title: "wed",
              disabled: details.type !== "update",
              actions:
                details.type !== "view"
                  ? (dialog: any, payload: any) => {
                      return [
                        {
                          onClick: async () => {
                            return updateunction(dialog, payload);
                          },
                        },
                      ];
                    }
                  : undefined,
            }}
            row={details.row ? details.row : null}
          />
        )}
        <Stack
          direction={"row"}
          sx={{
            width: "100%",
            p: "10px 0 15px 0",
            borderBottom: `1px solid ${globalColors.primary.borderColor}`,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack direction="row" spacing={1}>
            {statusFilters.map((status: any) => (
              <Chip
                key={status}
                label={`${status} (${status_counts?.[status] ?? 0})`}
                clickable={selectedStatus !== status}
                variant={selectedStatus === status ? "filled" : "outlined"}
                color={selectedStatus === status ? "primary" : "default"}
                onClick={
                  selectedStatus === status
                    ? () => {}
                    : () =>
                        setSelectedStatus(
                          selectedStatus === status ? null : status
                        )
                }
              />
            ))}
          </Stack>
          <Box sx={{ width: "250px" }}>
            {" "}
            <CustomSearch
              value={searchText}
              onChange={(value: any) => setSearchText(value)}
            />
          </Box>
        </Stack>
        <Stack sx={{ width: "100%", flex: 8,overflowY:"auto" }}>
          <CustomTable
            loading={loading}
            data={list}
            //   .map((item: { type: string }) => {
            //   return { ...item, type: convertFirstUpper(item.type) };
            // })}
            pagination={{ count: count, onChange: (page: any) => {
              console.log(page,"page")
            } }}
            columnsConfig={
              [
                {
                  field: "created_at",
                  width: 165,
                  sortable: false,
                  headerName: "Date",
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",
                  renderCell: (ss: any) => {
                    console.log(ss, "ssss");
                    return (
                      <Box
                        sx={{
                          whiteSpace: "normal",
                          width: "100%",
                          // textOverflow: "ellipsis",
                          // overflow: "hidden",
                        }}
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            fontSize: "0.75rem",
                          }}
                        >
                          <span style={{ fontSize: "0.7rem", color: "#888" }}>
                            Modified:
                          </span>
                          {formatTimestamp(ss.row.modified_at)}
                        </Typography>

                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            fontSize: "0.75rem",
                          }}
                        >
                          <span style={{ fontSize: "0.7rem", color: "#888" }}>
                            Created:
                          </span>
                          {formatTimestamp(ss.row.created_at)}
                        </Typography>
                      </Box>
                    );
                  },
                },
                {
                  field: "type",
                  width: 90,
                  sortable: false,
                  headerName: "Item Type",
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",
                  renderCell: (ss: any) => {
                    return convertFirstUpper(ss.row.type);
                  },
                },
                {
                  field: "topic_name",
                  width: 160,
                  sortable: false,
                  headerName: "Item Name",
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",

                  renderCell: (row: any) => {
                    return (
                      <Box
                        sx={{
                          whiteSpace: "normal",
                          width: "100%",
                          // textOverflow: "ellipsis",
                          // overflow: "hidden",
                        }}
                      >
                        {convertFirstUpper(row.row.topic_name)}
                      </Box>
                    );
                  },
                },
                {
                  field: "type_id",
                  width: 170,
                  sortable: false,
                  headerName: "Deletion Details",
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",
                  renderCell: (row: any) => {
                    // const button = {
                    //   content: "View",
                    //   icon: <Info />,
                    //   sx: {
                    //     fontSize: "0.75rem",
                    //     borderRadius: "8px",
                    //     padding: "4px 10px",
                    //     color: "#fff",
                    //     backgroundColor: "#4caf50",
                    //     "&:hover": {
                    //       backgroundColor: "#43a047",
                    //     },
                    //   },
                    //   onClick: () => {
                    //     setDetails({
                    //       open: true,
                    //       type: "view",
                    //       row: row.row,
                    //       [contents.feedback]: row.row.remark,
                    //     });
                    //   },
                    // };
                    const getLabel = (key: string) =>
                      deleteOptions.find((d) => d.api === key)?.label || "";
                    return (
                      <Box sx={{ height: "100%", ...rowVerticalCenter }}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Info
                            onClick={() => {
                              setDetails({
                                open: true,
                                type: "view",
                                row: row.row,
                                [contents.feedback]: row.row.remark,
                              });
                            }}
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                            color="action"
                          />
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              maxWidth: "200px", // or adjust based on your table layout
                            }}
                          >
                            {row.row.options?.map(
                              (opt: string, index: number) => (
                                <Tooltip key={index} title={getLabel(opt)}>
                                  <Typography
                                    key={index}
                                    variant="body2"
                                    sx={{
                                      fontSize: "0.75rem",
                                      px: 1.5,
                                      py: 0.5,
                                      backgroundColor: "#f0f0f0",
                                      borderRadius: "6px",
                                      color: "text.primary",
                                      flex: "1 0 30%", // roughly 3 per row
                                      textAlign: "center",
                                      maxWidth: "fit-content",
                                    }}
                                  >
                                    {opt}
                                  </Typography>
                                </Tooltip>
                              )
                            )}
                          </Box>
                        </Stack>
                      </Box>
                    );
                  },
                },
                {
                  field: "status",
                  width: 85,
                  sortable: false,
                  headerName: "Status",
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",
                  renderCell: (ss: any) => {
                    const getStyles = () => {
                      switch (ss.row.status.toLowerCase()) {
                        case "pending":
                          return {
                            backgroundColor: "#FFF7D1", // light mustard
                            color: "#7A6D00", // grayish text
                          };
                        case "completed":
                          return {
                            backgroundColor: "#D1FADF",
                            color: "#027A48",
                          };
                        case "rejected":
                          return {
                            backgroundColor: "#FFE4E4",
                            color: "#D92D20",
                          };
                        default:
                          return {
                            backgroundColor: "#E0E0E0",
                            color: "#333",
                          };
                      }
                    };
                    return (
                      <Box
                        px={"10px"}
                        py={"2px"}
                        borderRadius={2}
                        display="inline-block"
                        fontWeight={500}
                        fontSize={14}
                        sx={{
                          ...getStyles(),
                        }}
                      >
                        {ss.row.status}
                      </Box>
                    );
                  },
                },
                {
                  field: "Action",
                  headerName: "Action",

                  width: 132,
                  sortable: false,
                  // filterEditorProps: {
                  //   customFilterFunction: false,
                  // },
                  // defaultFlex: 1,
                  textAlign: "start",
                  textVerticalAlign: "middle",
                  headerAlign: "start",

                  renderCell: (ss: any) => {
                    return actionContent(ss);
                  },
                  // headerProps: { className:"noMenu" }
                },
              ] as any
            }
          />
        </Stack>
      </Stack>
    );
  };
  return (
    <Stack
      height="calc(100% - 35px)"
      width="calc(100% - 16px)"
      direction={"row"}
      m="20px 8px 15px"
      spacing={"8px"}
      // sx={{overflowX:"auto"}}
    >
      <Stack
        flex="8"
        sx={{
          borderRadius: "12px",
          background: globalColors.primary.pureWhite,
          p: "10px 10px 0",
          width: "calc(100% - 20px)",
          overflow: "auto",
        }}
      >
        <Stack
          flex="8"
          sx={{
            p: "0 10px",
            width: "calc(100% - 20px)",
            overflow: "auto",
          }}
        >
          {headerContent({
            text: `Pending Approvals`,
            sx: {
              p: "10px 0",
            },
            weight: "500",
            icons: [],
          })}
          <CustomTab
            selected={{
              content: tableContent("deleted"),
              id: 1,
              tab: "Deletions",
            }}
            onChange={(id: number) => {}}
            tabs={[
              {
                content: tableContent("deleted"),
                id: 1,
                tab: "Deletions",
              },
            ]}
            badgeCount={{ Deletions: count }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Pendingapproval;
